module.exports = __webpack_public_path__ + "static/img/adv3.8e55bdac.jpg";